import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getPost } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import PostBody from "@/components/site/PostBody";
import NewsletterSignup from "@/components/site/NewsletterSignup";
import { ArrowLeft, Loader2 } from "lucide-react";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    window.scrollTo(0, 0);
    getPost(slug)
      .then(setPost)
      .catch(() => setPost(null));
  }, [slug]);

  return (
    <div data-testid="blog-post-page">
      <Nav />
      <main className="pt-36 pb-24 md:pt-44">
        <article className="mx-auto max-w-3xl px-6 md:px-10">
          <Link
            to="/blog"
            data-testid="blog-back"
            className="group inline-flex items-center gap-2 text-sm uppercase tracking-[0.16em] text-muted-foreground hover:text-primary transition-colors"
          >
            <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" strokeWidth={1.5} />
            The Journal
          </Link>

          {post === undefined && (
            <div className="mt-20 flex justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-primary" strokeWidth={1.2} />
            </div>
          )}

          {post === null && (
            <div className="mt-16">
              <h1 className="font-serif text-4xl font-light">Post not found</h1>
              <p className="mt-4 text-muted-foreground">
                This piece may have moved. Return to{" "}
                <Link to="/blog" className="text-primary underline">
                  the Journal
                </Link>
                .
              </p>
            </div>
          )}

          {post && (
            <>
              <p className="mt-10 text-xs uppercase tracking-[0.2em] text-muted-foreground">
                {formatDate(post.created_at)} · {post.author}
              </p>
              <h1 className="mt-4 font-serif text-4xl md:text-6xl font-light leading-[1.02] tracking-tight">
                {post.title}
              </h1>
              {post.excerpt && (
                <p className="mt-6 text-xl text-muted-foreground leading-relaxed">
                  {post.excerpt}
                </p>
              )}
              {post.cover_image && (
                <div className="mt-10 overflow-hidden rounded-3xl">
                  <img src={post.cover_image} alt="" className="w-full object-cover" />
                </div>
              )}
              <div className="mt-12">
                <PostBody content={post.content} />
              </div>
            </>
          )}
        </article>

        <div className="mx-auto max-w-3xl px-6 md:px-10 mt-24">
          <NewsletterSignup />
        </div>
      </main>
      <Footer />
    </div>
  );
}
